export default "__VITE_ASSET__e1c7c88e__"